import React from 'react';
import MainTemplate from '../templates/MainTemplate';
import LoginForm from './LoginForm';

function CheckInLoginView({ viewParameters, error, handleChange, handleLogin, mdUpScreen, loading, buttonPressed, templateRef }) {

  return (
    <MainTemplate templateRef={templateRef} view={viewParameters}>
        <LoginForm viewParameters={viewParameters} error={error} handleChange={handleChange} handleLogin={handleLogin} mdUpScreen={mdUpScreen} loading={loading} buttonPressed={buttonPressed} />
    </MainTemplate>
  );
}


export default CheckInLoginView;